import {
  Card,
  CardContent,
  Stack,
  Typography,
  Grid,
  TextField,
  Box,
  FormControl,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import BugReportIcon from "@mui/icons-material/BugReport";
import { MobileDatePicker } from "@mui/x-date-pickers";

export default function InpatientStayAntiParasiteStep() {
  const {
    control,
    register,
    formState: { errors },
  } = useFormContext();
  const { t } = useTranslation();

  return (
    <Card variant="elevation" elevation={2}>
      <CardContent>
        <Stack spacing={3}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <BugReportIcon color="primary" />
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              {t("AntiParasite")}
            </Typography>
          </Stack>

          {/* Form Container */}
          <Box>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  inputProps={{ maxLength: 120 }}
                  label={t("AntiParasite")}
                  {...register("antiParasite")}
                  error={!!errors.antiParasite}
                  helperText={errors.antiParasite?.message}
                />
              </Grid>

              <Grid item xs={12}>
                <Controller
                  name="dateOfAntiParasite"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <FormControl fullWidth error={!!errors.dateOfAntiParasite}>
                      <MobileDatePicker
                        label={t("DateOfAntiParasite")}
                        value={value ?? null}
                        onChange={onChange}
                        format="DD/MM/YYYY"
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            error: !!errors.dateOfAntiParasite,
                            helperText: errors.dateOfAntiParasite?.message,
                          },
                        }}
                      />
                    </FormControl>
                  )}
                />
              </Grid>

              <Grid item xs={12}>
                <Controller
                  name="nextAntiParasiteDate"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <FormControl
                      fullWidth
                      error={!!errors.nextAntiParasiteDate}
                    >
                      <MobileDatePicker
                        label={t("AntiParasiteNextDate")}
                        value={value ?? null}
                        onChange={onChange}
                        format="DD/MM/YYYY"
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            error: !!errors.nextAntiParasiteDate,
                            helperText: errors.nextAntiParasiteDate?.message,
                          },
                        }}
                      />
                    </FormControl>
                  )}
                />
              </Grid>
            </Grid>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
}
